// extracted by mini-css-extract-plugin
export default {"section":"styles_section__FSF1i","textWrapper":"styles_textWrapper__hmRNy"};